var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5437 19.3062L20.0436 17.8061C19.8941 17.7424 19.728 17.729 19.5701 17.7679C19.4123 17.8068 19.2714 17.8959 19.1686 18.0218L17.6186 19.9156C15.186 18.7686 13.2283 16.8109 12.0813 14.3783L13.9751 12.8282C14.1013 12.7256 14.1905 12.5847 14.2295 12.4268C14.2684 12.269 14.2548 12.1027 14.1907 11.9532L12.6907 8.45316C12.6204 8.29204 12.4961 8.16048 12.3392 8.08119C12.1824 8.00189 12.0027 7.97982 11.8313 8.01878L8.58126 8.76879C8.416 8.80696 8.26855 8.90001 8.16298 9.03276C8.05742 9.16552 7.99996 9.33013 8 9.49974C8 17.5155 14.497 24 22.5003 24C22.6699 24.0001 22.8346 23.9427 22.9674 23.8371C23.1002 23.7315 23.1933 23.5841 23.2315 23.4187L23.9815 20.1687C24.0202 19.9964 23.9977 19.8161 23.9178 19.6587C23.8379 19.5012 23.7056 19.3766 23.5437 19.3062Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.ca51ecd2.svg";
export { ForwardRef as ReactComponent };